import http, { url } from '../../http'

const API_URL = "advance_report"

class evaluacionIdentificacionAPI {

  async save(resource) {
    const response = await http(`${API_URL}/save`, 'POST', resource)
    return response
  }

  async getAll(id, page, search) {
    const response = await http(`${API_URL}/index/${id}?page=${page}&search=${search}`,  'POST')
    return response
  } 
 
  async get(id) {
    const response = await http(`${API_URL}/index/${id}`,  'POST')
    return response
  }

  async getExcel(companyId) {
    let user = JSON.parse(localStorage.getItem('user'))

    if(user.token){
      return url(`${API_URL}/excelAdvance/${companyId}?&access_token=${user.token}`)
    } 
  }


  async getShow(id) {
    const response = await http(`${API_URL}/${id}`)
    return response
  }

  async update(id, resource) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', resource)
    return response
  }

  async delete(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  } 
  
}

export default new evaluacionIdentificacionAPI()